enum Size {
    '2XL' = 1536,
    XL = 1280,
    LG = 1024,
    MD = 768,
    SM = 640,
}

export { Size };
